'use strict';

var availablityStatusPill = require('../../../../../../../../../../_virtual/availablityStatusPill.cjs');

(function (exports) {

	exports.AvailabilityStatusPillAviarySizes = void 0;
	(function(AvailabilityStatusPillAviarySizes) {
	    AvailabilityStatusPillAviarySizes["xxsmall"] = "xxsmall";
	    AvailabilityStatusPillAviarySizes["xsmall"] = "xsmall";
	    AvailabilityStatusPillAviarySizes["small"] = "small";
	    AvailabilityStatusPillAviarySizes["medium"] = "medium";
	})(exports.AvailabilityStatusPillAviarySizes || (exports.AvailabilityStatusPillAviarySizes = {}));
	
} (availablityStatusPill.__exports));
//# sourceMappingURL=availablityStatusPill.cjs.map
